/**
 * Canonical group labels for the `ContactsAutocomplete` dropdown, in the order
 * the groups render. MUI's `groupBy` renders a new heading at every group
 * transition, so any option list handed to the autocomplete must keep options
 * of the same group contiguous — both the assembler that builds the list and
 * any code that re-orders it must derive group order from this single source.
 */
export const CONTACT_SUGGESTION_GROUPS = {
  teamContacts: 'Team Contacts',
  otherContacts: 'Other Contacts',
  googleContacts: 'Google Contacts',
  followUpBossContacts: 'Follow Up Boss Contacts',
} as const;

const GROUP_ORDER: readonly string[] = Object.values(CONTACT_SUGGESTION_GROUPS);

/** Sort rank of a group label; unknown labels sort last. */
export function contactSuggestionGroupRank(group: string): number {
  const index = GROUP_ORDER.indexOf(group);
  return index === -1 ? GROUP_ORDER.length : index;
}
